<ng-container *ngIf="!loading; else loadingHero">
  <div class="hero" *ngIf="content; else emptyHero">
    <div class="hero__header container col-12 col-6--md col-4--sm" [ngClass]="{ 'hero__header--carousel': heroes.length }">
      <air-breadcrumbs *ngIf="!isInMaintenance"></air-breadcrumbs>
      <air-partners-list *ngIf="!isInMaintenance && showPartnersList"></air-partners-list>
    </div>
    <carousel
      *ngIf="heroes.length"
      [autoSlideInterval]="9000"
      [showThumbs]="false"
      [userEventSource]="userEventSource"
      (slideChange)="onHeroChange($event)"
    >
      <ng-container *ngFor="let hero of heroes">
        <div *carouselSlide>
          <air-focal-image *ngIf="hero.image" class="hero__image" [image]="hero.image"></air-focal-image>
          <div class="container">
            <div class="grid">
              <div class="hero__content col-7 col-5--md col-4--sm">
                <h1 *ngIf="hero.title" class="hero__title">{{ hero.title }}</h1>
                <div *ngIf="hero.description?.length || hero.points" class="hero__body d--flex">
                  <air-miles-sticker *ngIf="hero.points" [points]="hero.points" [size]="'md'"></air-miles-sticker>
                  <div
                    class="hero__body-text"
                    *ngIf="hero.description?.length"
                    [internalInnerHtml]="hero.description"
                    [userEventSource]="userEventSource"
                  ></div>
                </div>
                <div *ngIf="hero.links?.length" class="hero__cta button__group">
                  <a
                    *ngFor="let link of hero.links; let i = index"
                    [airLink]="link"
                    [userEventSource]="userEventSource"
                    class="button button--wide"
                    [ngClass]="i === 0 ? 'button--cta' : 'button--border button--border--white button--transparent'"
                  >
                    {{ link.label }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </carousel>
  </div>
</ng-container>

<ng-template #emptyHero>
  <div class="hero hero--empty">
    <div class="container">
      <div class="grid">
        <div class="hero__header col-12 col-6--md col-4--sm">
          <air-breadcrumbs></air-breadcrumbs>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #loadingHero>
  <div class="hero loading">
    <div class="container">
      <div class="grid">
        <div class="hero__header col-12 col-6--md col-4--sm"></div>
        <div class="hero__content col-7 col-5--md col-4--sm"></div>
      </div>
    </div>
  </div>
</ng-template>
